import { render } from "./SelectLocationForm.vue?vue&type=template&id=4ff15cc4&scoped=true"
import script from "./SelectLocationForm.vue?vue&type=script&lang=js"
export * from "./SelectLocationForm.vue?vue&type=script&lang=js"

import "./SelectLocationForm.vue?vue&type=style&index=0&id=4ff15cc4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ff15cc4"]])

export default __exports__